module.exports = __webpack_public_path__ + "static/media/LP.5cf70b7b.svg";